export default __webpack_public_path__ + "static/media/Opteon_Main_Logo_White_Text.65147a16.png";